<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules")
  el-date-picker.width-full(
    ref="fieldEditor",
    v-show="!isReadMode",
    v-model="fieldModel",
    v-bind="inputBind",
    @focus="handleFocusCustomEvent",
    @blur="handleBlurCustomEvent",
    @change="handleChangeEvent"
  )
  template(v-if="isReadMode")
    span.readonly-mode-field {{ displayValue }}
</template>

<script>
import { formatDate, parseDate } from "element-ui/src/utils/date-util";
import { staticMixins } from "../utils";
export default {
  name: "DateWidget",
  componentName: "FieldWidget",
  mixins: [staticMixins],
  computed: {
    displayValue() {
      const {
        fieldModel: value,
        inputBind: { valueFormat, format }
      } = this;
      if (value) {
        const date = parseDate(value, valueFormat);
        const displayValue = formatDate(date, format);
        return displayValue;
      } else {
        return "--";
      }
    },
    inputBind() {
      const { options } = this;
      return {
        type: options.type,
        readonly: options.readonly,
        disabled: options.disabled,
        clearable: options.clearable,
        editable: options.editable,
        format: options.format,
        valueFormat: options.valueFormat,
        placeholder: options.placeholder || "选择日期"
      };
    }
  },
  methods: {
    preventDesign() {}
  }
};
</script>

<style lang="scss" scoped>
.width-full {
  display: block;
  width: 100%;
}
</style>
